import { createStrictContext } from 'utils/createContext'
import { IFINotificationsContext } from './types'
import { useIfiNotificationsQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useRecipientsFn } from 'components/CIMSNotifications/hooks/useRecipientsFn'
import { useGlobalState } from 'context/GlobalStateContext'

const { Provider, useContextFn } = createStrictContext<IFINotificationsContext>(
  'IFINotificationsContext'
)
export const useIFINotificationsContext = useContextFn

const IFINotificationsProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { data, loading, refetch } = useIfiNotificationsQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { projectId: projectId! },
  })
  const recipients = useRecipientsFn({
    data: data?.project,
    getter: (id, { ifiNotifications }) =>
      ifiNotifications.find(
        ({ notificationEventId }) => notificationEventId === id
      )?.recipients,
    fallback: {
      __typename: 'IFINotificationRecipients',
      every: null,
      asphaltLot: null,
      concreteTest: null,
      dailyInspectionControlPoint: null,
      dailyInspectionInspection: null,
      dailyInspectionPunchList: null,
      densityLot: null,
      densityTest: null,
    },
  })
  return (
    <Provider
      value={{
        loading,
        refetch,
        notifications: data?.project?.ifiNotifications ?? [],
        recipients,
      }}
    >
      {children}
    </Provider>
  )
}

export default IFINotificationsProvider
